/** returns true if hotel page */
export function isHotelPage(): boolean {
	return !!document.querySelector('.page_hotel');
}

/** returns true if hotel page */
export function isHotelList(): boolean {
	return !!document.querySelector('.page_hotel_list');
}
